import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import React, { memo } from "react";
import { Controller } from "react-hook-form";
import RequiredTitle from "./RequiredTitle";

const CkEditorField = ({ input, control, defaultValue, error }) => {
  const { name, type, label, validation, defaultValues = defaultValue, ...rest } = input;
  const { sm = 12, md = 12, lg = 12 } = input?.alignment || {};

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <div className="custom-ekeditor">
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValues || ""}
          rules={validation}
          render={({ field }) => (
            <>
              <CKEditor
                editor={ClassicEditor}
                data={field.value} // Bind CKEditor value to react-hook-form field value
                onReady={(editor) => {
                  // Optionally, store the editor instance for later use
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  field.onChange(data); // Update react-hook-form value when CKEditor changes
                }}
                onBlur={(event, editor) => {
                  field.onBlur(); // Trigger blur event for react-hook-form validation
                }}
              />
              {error && <div className="invalid-feedback">{error}</div>}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default memo(CkEditorField);
